import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import {
  CheckboxGroupProps as CheckboxGroupPlatformProps,
  CheckboxGroupDefinition,
} from '@wix/thunderbolt-components';
import { props as viewerPropsMapper } from './CheckboxGroup.mapper';

const props = composeMapper<
  PreviewWrapperProps<CheckboxGroupPlatformProps>,
  CheckboxGroupDefinition,
  CheckboxGroupPlatformProps
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState', 'shouldResetComponent', 'componentViewMode'],
    remove: ['fullNameCompType', 'language', 'compId', 'trackClicksAnalytics'],
  },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);

    const { shouldResetComponent, compPreviewState, componentViewMode } =
      dependencies;

    return {
      ...viewerProps,
      trackClicksAnalytics: false,
      previewWrapperProps: {
        componentViewMode,
        shouldResetComponent,
        compPreviewState,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
